import { CSSProperties } from 'react';
import Skeleton from 'react-loading-skeleton';
import { AsyncBoundary } from '@toss/async-boundary';
import { useRouter } from 'next/router';
import { logger } from '@zep/core-logger';
import { useStoreInquiryBannerList } from '../../../../services';
import S from './InquiryBanner.module.scss';
import { StoreBannerButton } from './StoreBannerButton';
import { StoreBannerDescription } from './StoreBannerDescription';
import { StoreBannerImage } from './StoreBannerImage';
import { storeBannerItemSchema } from './types';
export const InquiryBanner = (props: {
  style?: CSSProperties;
}) => {
  return <div className={S.inquiry_banner_wrapper} style={props.style} data-sentry-component="InquiryBanner" data-sentry-source-file="InquiryBanner.tsx">
      <AsyncBoundary pendingFallback={<Skeleton height="100%" width="100%" />} rejectedFallback={() => <Skeleton height="100%" width="100%" />} data-sentry-element="AsyncBoundary" data-sentry-source-file="InquiryBanner.tsx">
        <InquiryBannerView data-sentry-element="InquiryBannerView" data-sentry-source-file="InquiryBanner.tsx" />
      </AsyncBoundary>
    </div>;
};
export const InquiryBannerView = () => {
  const {
    data
  } = useStoreInquiryBannerList({
    suspense: true
  });
  const router = useRouter();
  const firstItem = storeBannerItemSchema.parse(data?.[0]);
  const handleClickBanner = () => {
    logger.track('store_banner_click', {
      banner_id: firstItem.id,
      banner_title: firstItem.pcTitle
    });
    if (firstItem.link.startsWith('/')) {
      router.push(firstItem.link);
    } else {
      window.open(firstItem.link, '_blank');
    }
  };
  return <div className={S.inquiry_banner} onClick={handleClickBanner} data-sentry-component="InquiryBannerView" data-sentry-source-file="InquiryBanner.tsx">
      <div className={S.info_container} style={{
      backgroundColor: firstItem.backgroundColor
    }}>
        <StoreBannerDescription bannerData={firstItem} data-sentry-element="StoreBannerDescription" data-sentry-source-file="InquiryBanner.tsx" />
        <StoreBannerButton bannerData={firstItem} data-sentry-element="StoreBannerButton" data-sentry-source-file="InquiryBanner.tsx" />
      </div>
      <StoreBannerImage bannerData={firstItem} data-sentry-element="StoreBannerImage" data-sentry-source-file="InquiryBanner.tsx" />
    </div>;
};